import { ROOT_STATUS } from '.';

export const STATUSES = {
  ...ROOT_STATUS,
  STATUS_DRAFT: {
    key: 'STATUS_DRAFT',
    value: 'Draft',
    color: 'secondary',
    icon: '',
  },
  STATUS_PUBLISHED: {
    key: 'STATUS_PUBLISHED',
    value: 'Published',
    color: 'primary',
    icon: '',
  },
};

export const TYPE_STANDARD = 'TYPE_STANDARD';
export const TYPE_GHC = 'TYPE_GHC';

export const TYPES = {
  [TYPE_STANDARD]: {
    key: TYPE_STANDARD,
    value: 'Standard',
  },
  [TYPE_GHC]: {
    key: TYPE_GHC,
    value: 'General Health Check',
  },
};

export const TYPE_OPTIONS = [
  {
    key: TYPE_STANDARD,
    value: 'Standard',
  },
  {
    key: TYPE_GHC,
    value: 'General Health Check',
  },
];
